import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "onClick", "disabled", "selected", "className", "id"];
import React, { forwardRef } from 'react';
import classnames from 'classnames';
import { func, node, bool, string } from 'prop-types';
import { useIsFocusVisible, useForkRef } from '@material-ui/core/utils';
import useStyles from './Selector.styles';
const Selector = /*#__PURE__*/forwardRef(function Selector(_ref, ref) {
  let {
      children,
      onClick,
      disabled,
      selected,
      className,
      id
    } = _ref,
    allProps = _objectWithoutProperties(_ref, _excluded);
  const {
    isFocusVisible,
    onBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible(); // Internet Explorer & Safari support for :focus-visible
  const handleRef = useForkRef(focusVisibleRef, ref);
  const [focusVisible, setFocusVisible] = React.useState(false);
  if (disabled && focusVisible) {
    setFocusVisible(false);
  }
  const classes = useStyles();
  const selectorClasses = classnames(className, classes.root, {
    [classes.disabled]: disabled,
    [classes.selected]: selected && !disabled,
    [classes.focusVisible]: focusVisible
  });
  const onFocus = function (event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }
  };
  const onBlur = function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }
  };
  return /*#__PURE__*/React.createElement("label", {
    className: selectorClasses,
    htmlFor: id
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    ref: handleRef,
    type: "radio",
    id: id,
    className: classes.input,
    checked: selected,
    onChange: onClick,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled
  }, allProps)), children);
});
Selector.propTypes = {
  /**
   * The content of the component.
   */
  children: node,
  /**
   * Callback fired when a "click" event is detected.
   */
  onClick: func,
  /**
   * If true, the selector will be disabled.
   */
  disabled: bool,
  /**
   * If true, the selector will have the selected style.
   */
  selected: bool,
  /**
   * The id of the input element.
   */
  id: string,
  /**
   * The CSS class name of the wrapper element.
   */
  className: string
};
Selector.defaultProps = {
  children: null,
  onClick: function () {},
  disabled: false,
  selected: undefined,
  id: null,
  className: ''
};
export default Selector;